import { render, staticRenderFns } from "./SBHelp.vue?vue&type=template&id=0bd4a1c3"
import script from "./SBHelp.vue?vue&type=script&lang=js"
export * from "./SBHelp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports